import { Box, Typography } from "@mui/material";
import { useLocation } from "react-router-dom";
import BonificationPreferences from "./preferences/BonificationPreferences";
import DriversServicePreferences from "./preferences/DriversServicePreferences";
import DriversJourneyPreferences from "./preferences/DriversJourneyPreferences";
import MobileAccessPreferences from "./preferences/MobileAccessPreferences";
import ChangesHistory from "./preferences/ChangesHistory";

function BackOfficeCompanyPreferences() {
  const location = useLocation()

  return (
    <Box sx={{ display: 'flex', justifyContent: 'center', marginBlockStart: '1rem'}}>
      <Box sx={{ display: 'flex', justifyContent: 'center', flexDirection: 'column', width: '85%' }}>
        <Typography sx={{paddingBlock: '1.5rem'}} variant="h5">Preferências</Typography>
        <BonificationPreferences />
        <DriversServicePreferences />
        <DriversJourneyPreferences />
        <MobileAccessPreferences />
        <ChangesHistory />
      </Box>
    </Box>
  );
}

export default BackOfficeCompanyPreferences;